import React from "react";
import {
  Box,
  ToggleButton,
  Typography,
  ToggleButtonGroup,
  Grid,
} from "@mui/material";

interface ThresholdValues {
  ThresholdValueGC?: number | null;
  ThresholdValueLC?: number | null;
  ThresholdPercent?: number | string | null;
}

interface KpiFiltersProps {
  thresholdValues: ThresholdValues;
  currencyMode: string;
  setCurrencyMode: (mode: string) => void;
  currency: string;
  showToggle?: boolean; // Optional prop to control visibility of the toggle
  disabled?: boolean;
}

const KpiFilters: React.FC<KpiFiltersProps> = ({
  thresholdValues,
  currencyMode,
  setCurrencyMode,
  currency,
  showToggle = false,
  disabled = false,
}) => (
  <Box gap={1} mt={0}>
    <Grid container className="kpiFilters">
      {/* all dropdowns */}
      <Grid size={{ xs: 12, md: 4.5, sm: 4.5 }}>
        <Grid component="section">
          <div>
            <label>Threshold Value (GC) (K)</label>
            <input
              type="text"
              value={
                thresholdValues?.ThresholdValueGC !== undefined &&
                thresholdValues?.ThresholdValueGC !== null
                  ? Number(thresholdValues.ThresholdValueGC).toFixed(2)
                  : "0.00"
              }
              disabled
            />
          </div>
        </Grid>
      </Grid>
      <Grid size={{ xs: 12, md: 4, sm: 4 }}>
        <Grid component="section">
          <div>
            <label>Threshold Value (LC) (K)</label>
            <input
              type="text"
              value={
                thresholdValues?.ThresholdValueLC !== undefined &&
                thresholdValues?.ThresholdValueLC !== null
                  ? Number(thresholdValues.ThresholdValueLC).toFixed(2)
                  : "0.00"
              }
              disabled
            />{" "}
          </div>
        </Grid>
      </Grid>
      <Grid size={{ xs: 12, md: 3, sm: 3 }}>
        <Grid component="section">
          <div>
            <label>Threshold %</label>
            <input
              type="text"
              value={`${thresholdValues?.ThresholdPercent} %` || "0%"}
              disabled
            />
          </div>
        </Grid>
      </Grid>
    </Grid>

    <div className="currencyDisplay">
      <Grid container spacing={1} sx={{ mt: 1.5 }}>
        {/* all dropdowns */}
        <Grid size={{ xs: 12, md: 6, sm: 12 }}>
          <Grid component="section">
            {showToggle && (
              <ToggleButtonGroup
                disabled={disabled}
                value={currencyMode}
                size="small"
                color="primary"
                exclusive
                onChange={() => {
                  setCurrencyMode("local");
                }}
                sx={{
                  borderRadius: "25px",
                  overflow: "hidden",
                  border: "1px solid #ccc",
                }}
              >
                <ToggleButton
                  value="local"
                  sx={{
                    textTransform: "none",
                    fontWeight: currencyMode === "local" ? "bold" : "bold",
                    bgcolor:
                      currencyMode === "local" ? "#18B4FF" : "transparent",
                    color: currencyMode === "local" ? "#fff" : "inherit",
                    px: 2,
                  }}
                >
                  Local Currency
                </ToggleButton>
                <ToggleButton
                  value="euro"
                  onChange={() => {
                    setCurrencyMode("euro");
                  }}
                  sx={{
                    textTransform: "none",
                    fontWeight: currencyMode === "euro" ? "bold" : "bold",
                    bgcolor:
                      currencyMode === "euro" ? "#18B4FF" : "transparent",
                    color: currencyMode === "euro" ? "#fff" : "inherit",
                    px: 2,
                  }}
                >
                  Euro Value
                </ToggleButton>
              </ToggleButtonGroup>
            )}
          </Grid>
        </Grid>
        <Grid size={{ xs: 12, md: 2.5, sm: 4 }} sx={{ mt: 1 }}>
          <Grid component="section">
            <Typography sx={{ fontWeight: 400 }}>
              <b>Currency :</b>{" "}
              <label>{currencyMode === "local" ? currency : "Euro"}</label>
            </Typography>
          </Grid>
        </Grid>
        <Grid size={{ xs: 12, md: 2.5, sm: 4 }} sx={{ mt: 1 }}>
          <Grid component="section">
            <Typography sx={{ fontWeight: 400 }}>
              <b>Values in:</b>
              <label>'000</label>{" "}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </div>
  </Box>
);

export default KpiFilters;
